<template><!-- svgo-optimised -->
<svg class="icon icon__unmute" viewBox="0 0 16 15" xmlns="http://www.w3.org/2000/svg">
<path d="M9.403 1.582c3.147 0 5.694 2.561 5.694 5.725 0 3.164-2.547 5.725-5.694 5.725" stroke="#000000" stroke-miterlimit="10"/>
<path d="M9.403 5.042a2.26 2.26 0 0 1 2.253 2.265 2.26 2.26 0 0 1-2.253 2.265" stroke="#000000" stroke-miterlimit="10"/>
<path d="M0 7.855v2.463h4.004L7.5 14.29V.44L4.004 4.404H0v2.462" fill="#000000"/>
<path d="M2 1.5 15 14" stroke="#000000"/>
<defs><path d="M0 0h16v15H0z" fill="#000000"/></defs></svg></template>